import { getTranslate } from 'legacy-src/utilities/i18n'
import Markdown from 'markdown-to-jsx'
import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import Icon from '../icons/Icon'

type ModalPropTypes = {
  children: React.ReactNode
  centered?: boolean
  className?: string
  closeModal?: null | (() => void)
  isScrollable?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
  title?: string
  noGutters?: boolean
  visible: boolean
  onBack?: () => void
  backText?: string
  video?: boolean
}

const Modal: React.FC<ModalPropTypes> = ({
  children,
  centered = true,
  className = '',
  closeModal,
  isScrollable = false,
  size = 'md',
  title,
  noGutters = false,
  visible,
  backText,
  onBack,
  video = false,
}) => {
  const { t } = getTranslate()
  if (!visible) {
    return null
  }

  const shouldClose = typeof closeModal === 'function'

  return (
    <div
      className={cn('modal', { 'modal--no-gutters': noGutters, 'modal--video': video }, className)}
      role="dialog"
      tabIndex={-1}
    >
      {shouldClose && <div className="modal__close-bg" onClick={closeModal} />}
      <div
        className={cn(
          'modal-dialog',
          { 'modal-dialog-centered': centered, 'modal-dialog-scrollable': isScrollable },
          `modal-${size}`,
        )}
        role="document"
      >
        <div className="modal-content">
          {(title || backText || shouldClose) && (
            <div className="modal-header">
              {backText && (
                <button className={cn('modal__back', '!font-normal !normal-case')} onClick={onBack} type="button">
                  <Icon icon="back" size="native" color="primary" />
                  {t(backText)}
                </button>
              )}
              {title && (
                <div className="modal__title">
                  <h3>
                    <Markdown>{t(title, {}, { fallback: '' })}</Markdown>
                  </h3>
                </div>
              )}
              {shouldClose && (
                <button className="modal__close" onClick={closeModal} type="button">
                  <Icon icon="cross" size="sm" color="white" />
                </button>
              )}
            </div>
          )}
          <div className="modal-body">
            <div className="modal__scroll-view">{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
